export default __webpack_public_path__ + "static/media/4.e5f2f937.jpg";